import React from 'react';
import PropTypes from 'prop-types';
import DropdownCycleFilter from 'components/common/DropdownCycleFilter';
import SearchMember from 'components/Organizations/SingleOrganization/Groups/Member/SearchMember';
import SelectMember from 'components/Organizations/SingleOrganization/Groups/Member/SelectMember';

const GroupFilter = ({
  category,
  handleChange,
  resourceId,
  form,
  group,
}) => {
  if (category === 'transactions') {
    return (
      <>
        <DropdownCycleFilter
          handleChange={(e, { cycle_id }) =>
            handleChange(e, { name: 'cycle_id', value: cycle_id })
          }
          label="Cycle"
          name="cycle_id"
          group={group}
        />
        <SelectMember
          label="Member Name"
          name="user_id"
          handleChange={handleChange}
          groupId={resourceId}
          defaultValue={form.user_id}
        />
      </>
    );
  }

  return (
    <SearchMember
      label="Member Name"
      name="search"
      handleChange={handleChange}
      groupId={resourceId}
      defaultValue={form.search}
    />
  );
};

GroupFilter.defaultProps = {
  resourceId: null,
  group: {},
};

GroupFilter.propTypes = {
  category: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  form: PropTypes.instanceOf(Object).isRequired,
  resourceId: PropTypes.string,
  group: PropTypes.instanceOf(Object),
};

export default GroupFilter;
